import React from 'react'
import { useGetBusinessIfExists } from '@marketing-milk/frontend'

interface Props {
  children: React.ReactNode
  /** Smaller line above the subject — the parent record on a detail page. */
  eyebrow?: React.ReactNode
}

export const PageBarSubject = ({ children, eyebrow }: Props) => {
  const business = useGetBusinessIfExists()

  return (
    <div className="flex min-w-0 max-w-full flex-col sm:flex-row sm:items-center sm:gap-2">
      {business && (
        <>
          <span
            title={business.businessName}
            className="max-w-full truncate text-xs text-mm-neutral-1-600 sm:max-w-[180px]"
          >
            {business.businessName}
          </span>
          <span className="hidden text-mm-neutral-1-400 sm:block" aria-hidden>
            ·
          </span>
        </>
      )}
      <div className="min-w-0">
        {eyebrow && <div className="truncate text-xxs text-mm-neutral-1-500">{eyebrow}</div>}
        {/* The subject has to out-weigh the actions and banners sharing the bar;
            at toolbar size it reads as another control rather than the page. */}
        <h1 className="truncate text-xl font-semibold text-mm-neutral-1-900">{children}</h1>
      </div>
    </div>
  )
}
